import { Message } from 'services/conversations/types';
import { parseISO } from 'date-fns';
import { TemplateType } from 'services/whatsaapTemplates/types';

export const isLastMessageRestartConversation = (messages: Message[]) => {
  // Sort the messages by updatedAt field in descending order to get the latest message

  const clonedMessage = [...messages];
  clonedMessage.sort(
    (a, b) => parseISO(b.updatedAt).getTime() - parseISO(a.updatedAt).getTime()
  );

  return clonedMessage[0]?.template?.type === TemplateType.RESTART_OPEN_MESSAGE;
};
